<style type="text/css">
  .parameterDefaultStyle {
    font-weight: normal !important;
    font-style: initial !important;
    color: initial !important;
  }
  :host ::ng-deep .mat-tab-label-active {
    font-size: inherit;
  }

  :host ::ng-deep .mat-tab-label {
    color: rgba(0, 0, 0, .54);
    opacity: 1;
  }

  :host ::ng-deep .mat-tab-label-active {
    color: #3F51B5;
  }

  :host ::ng-deep .mat-ink-bar {
    background-color: #FFC107 !important;
    height: 3px;
  }

  :host ::ng-deep .childTabs .mat-ink-bar {
    background-color: #5b6bc1 !important;
  }

  :host ::ng-deep .mat-tab-header {
    border-bottom: unset;
  }
  mat-tab-group {
    border-style: solid;
    border-width: 0;
    border-color: lightgray;
    border-bottom-width: 1px;
  }
</style>

<div mat-dialog-title style="margin-bottom: unset;">{{selectedReport.Description}}</div>

<mat-dialog-content>
  <form id="v9ReportParameterForm">
    <mat-tab-group *ngIf="tabNames.length > 0">
      <mat-tab *ngFor="let tab of tabNames;let index = index" label="{{tab | translate | uppercase}}">
        <table style="max-width: 100%; padding: 10px; overflow: hidden;margin-top: 10px;" *ngIf="chunkedParameters != null">
          <tr *ngFor="let parameterRow of chunkedParameters.Rows | v9ReportParameterTabsFilter : tab"
            [style.border-top]="parameterRow.IncludeLineAtStartOfGroup ? '1px solid': ''"
            [style.border-bottom]="parameterRow.IncludeLineAtEndOfGroup ? '1px solid': ''">
            <td *ngFor="let parameter of parameterRow.Parameters" [colSpan]="parameter.SpanNumberOfColumns"
              [rowSpan]="parameter.SpanNumberOfRows" style="padding-left: 10px; padding-right: 10px; min-width: 130px;"
              [style.max-width]="200*parameter.SpanNumberOfColumns + 'px'">
    
              <div [ngStyle]="getParameterStyle(parameter)">
                <!-- Label -->
                <span
                  *ngIf="parameter.ControlType=='lbl' && parameter.Name != '' && parameter.IsVisible == true">{{parameter.Name}}</span>
    
                <!-- Textbox -->
                <tyl-form-field label="{{parameter.Name}}"
                  *ngIf="parameter.ControlType == 'txt' && parameter.IsVisible == true" class="parameterDefaultStyle">
                  <input matInput [type]="parameter.DataType == 'VARCHAR' ? 'text': 'number'"
                    name="txt{{parameter.Name}}_{{parameter.Id}}" [(ngModel)]="parameter.Value"
                    maxlength="{{parameter.MaxLength}}" id="txt{{parameter.ParameterName}}_{{parameter.Id}}"
                    [disabled]="parameter.Disabled" [required]="parameter.IsRequired" />
                </tyl-form-field>
    
                <!-- Multi Line Textbox -->
                <tyl-form-field label="{{parameter.Name}}" style="width:95%;"
                  *ngIf="parameter.ControlType == 'rtxt' && parameter.IsVisible == true"
                  hint="{{parameter.MaxLength - parameter.Value.length}} characters left" class="parameterDefaultStyle">
                  <textarea matInput #txtSummary type="text" name="txt{{parameter.Name}}_{{parameter.Id}}"
                    [(ngModel)]="parameter.Value" id="txt{{parameter.ParameterName}}_{{parameter.Id}}"
                    maxlength="{{parameter.MaxLength}}" style="resize: none; min-height: 150px;" [disabled]="parameter.Disabled"
                    [required]="parameter.IsRequired"></textarea>
                </tyl-form-field>
    
                <!-- Date Picker -->
                <tyl-datepicker label="{{parameter.Name}}" [ngStyle]="getParameterStyle(parameter)"
                  *ngIf="parameter.ControlType == 'dtp' && parameter.IsVisible == true"
                  id="txt{{parameter.ParameterName}}_{{parameter.Id}}" [(value)]="parameter.Value"
                  [disabled]="parameter.Disabled" [isRequired]="parameter.IsRequired" class="parameterDefaultStyle">
                </tyl-datepicker>
    
                <!-- Checkbox -->
                <tyl-checkbox *ngIf="parameter.ControlType == 'chk' && parameter.IsVisible == true"
                  [(checked)]="parameter.Value" (change)="parameterChanged(parameter)"
                  id="Cb{{parameter.ParameterName}}_{{parameter.Id}}" name="Cb{{parameter.Name}}_{{parameter.Id}}"
                  [disabled]="parameter.Disabled" class="parameterDefaultStyle">
                  {{parameter.Name}}
                </tyl-checkbox>
    
                <!-- Checkbox List -->
                <div *ngIf="parameter.ControlType == 'cbl' && parameter.IsVisible == true">
                  <span *ngIf="parameter.Name != ''">{{parameter.Name}}</span>
    
                  <div style="display: flex; flex-wrap: wrap;"
                    [style.flex-direction]="parameter.ShowOptionsVertically ? 'column' : 'row'"
                    [style.padding-left]="parameter.ChildPaddingLeft + 'px'" class="parameterDefaultStyle">
                    <tyl-checkbox *ngFor="let dataItem of parameter.DataSource; let i = index" style="padding-right: 15px;"
                      [(checked)]="dataItem.IsSelected" [value]="dataItem.ValueField"
                      id="cbl{{parameter.ParameterName}}_{{parameter.Id}}_{{i}}"
                      name="cbl{{parameter.Name}}_{{parameter.Id}}_{{i}}" [disabled]="parameter.Disabled">
                      {{dataItem.TextField}}
                    </tyl-checkbox>
                  </div>
                </div>
    
                <!-- Dropdown List -->
                <tyl-form-field label="{{parameter.Name}}"
                  *ngIf="parameter.ControlType == 'ddl' && parameter.IsVisible == true" [ngStyle]="getParameterStyle(parameter)" class="parameterDefaultStyle">
                  <mat-select name="ddl{{parameter.Name}}_{{parameter.Id}}" [(ngModel)]="parameter.Value"
                    id="ddl{{parameter.ParameterName}}_{{parameter.Id}}" (selectionChange)="parameterSelectionChange(parameter);parameterChanged(parameter);" [disabled]="parameter.Disabled"
                    [required]="parameter.IsRequired">
                    <mat-option *ngFor="let dataItem of parameter.DataSource" [value]="dataItem.ValueField">
                      {{dataItem.TextField}}
                    </mat-option>
                  </mat-select>
                </tyl-form-field>
    
                <!-- Dropdown List Multiple Setect -->
                <tyl-form-field label="{{parameter.Name}}"
                  *ngIf="parameter.ControlType == 'ddcbl' && parameter.IsVisible == true">
                  <mat-select id="ddcbl{{parameter.Name}}_{{parameter.Id}}" name="ddcbl{{parameter.Name}}_{{parameter.Id}}"
                    [(ngModel)]="parameter.Value" multiple>
                    <mat-select-trigger *ngIf="parameter.Value && parameter.Value.length > 1">
                      <span style="font-style:italic;">Multiple Selected</span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let dataItem of parameter.DataSource" [(value)]="dataItem.ValueField">
                      {{dataItem.TextField}}
                    </mat-option>
                  </mat-select>
                </tyl-form-field>
    
                <!-- Radio Button List -->
                <div *ngIf="parameter.ControlType == 'rbl' && parameter.IsVisible == true">
                  <span *ngIf="parameter.Name != ''">{{parameter.Name}}</span>
    
                  <div [style.padding-left]="parameter.ChildPaddingLeft + 'px'" class="parameterDefaultStyle">
                    <mat-radio-group name="rbl{{parameter.Name}}_{{parameter.Id}}" [(ngModel)]="parameter.Value"
                      id="rbl{{parameter.ParameterName}}_{{parameter.Id}}" style="display:flex; flex-wrap: wrap;"
                      [style.flex-direction]="parameter.ShowOptionsVertically ? 'column' : 'row'"
                      [disabled]="parameter.Disabled" (ngModelChange)="parameterChanged(parameter)">
                      <mat-radio-button *ngFor="let dataItem of parameter.DataSource" [value]="dataItem.ValueField">
                        {{dataItem.TextField}}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
    
                <!-- Student Selection -->
                <div *ngIf="parameter.ControlType == 'ssrbl' && parameter.IsVisible == true">
                  <span *ngIf="parameter.Name != ''">{{parameter.Name}}</span>
                  <div [style.padding-left]="parameter.ChildPaddingLeft + 'px'" class="parameterDefaultStyle">
                    <mat-radio-group name="ssrbl{{parameter.Name}}_{{parameter.Id}}" [(ngModel)]="parameter.Value"
                      id="ssrbl{{parameter.ParameterName}}_{{parameter.Id}}" style="display:flex; flex-wrap: wrap;"
                      [style.flex-direction]="parameter.ShowOptionsVertically ? 'column' : 'row'" [disabled]="parameter.Disabled"
                      class="parameterDefaultStyle">
                      <mat-radio-button *ngFor="let dataItem of parameter.DataSource" [(value)]="dataItem.ValueField">
                        {{dataItem.TextField}}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
    
                <div style="max-height: 300px;" *ngIf="parameter.ControlType == 'grid' && parameter.IsVisible == true">
                  <mat-table [dataSource]="parameter.GridDataSources" matSortDisableClear matSort (matSortChange)="sortData($event,parameter.GridDataSources)"  style="display: grid;">
                    <ng-container *ngFor="let disCol of parameter.ColumnToDisplay; let colIndex = index" matColumnDef="{{disCol}}">
                      <mat-header-cell *matHeaderCellDef [mat-sort-header]=" disCol != 'Selected' ? disCol : null" [disabled]=" disCol=='Selected' ? true : false "  style="padding-left: 10px;">
                        <span *ngIf="disCol != 'Selected'">{{disCol}}</span>
                        <tyl-checkbox [(checked)]="selectAllGridRecords" (change)="selectAllGridRecordsChange()"
                          *ngIf="disCol == 'Selected'">
                        </tyl-checkbox>
                        <filter [data]="parameter.GridDataSources" columnName="{{disCol!= 'Selected' ? disCol : null}}" [hidden]=" disCol=='Selected' ? true : false " dataType="string"></filter>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let row" style="padding-left: 10px;">
                        <span *ngIf="disCol != 'Selected'" style="white-space: break-spaces;">
                          {{row[disCol]}}
                        </span>                    
                        <tyl-checkbox [(checked)]="row.Selected" *ngIf="disCol == 'Selected'"></tyl-checkbox>                    
                      </mat-cell>
                    </ng-container>
    
                    <mat-header-row *matHeaderRowDef="parameter.ColumnToDisplay; sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: parameter.ColumnToDisplay;" 
                    style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple class="element-row"></mat-row>
                  </mat-table>
                </div>

                <div *ngIf="parameter.ControlType == 'img' && parameter.IsVisible == true">
                  <img alt="Image" [src]="parameter.Value" />
                </div>

                <div *ngIf="parameter.ControlType == 'btn' && parameter.IsVisible == true" >
                  <button id="btn{{parameter.ParameterName}}_{{parameter.Id}}" (click)="saveRCMessages()">SAVE CHANGES TO MESSAGES</button>
                  <!-- <tyl-button  (clickEvent)="searchClick(parameter)"
                   translate>SAVE CHANGES TO MESSAGES</tyl-button> -->
                </div>
    
                <div *ngIf="parameter.Hint != '' && parameter.IsVisible == true">{{parameter.Hint}}</div>
              </div>
            </td>
          </tr>
        </table>
      </mat-tab>
    </mat-tab-group>

    <table style="max-width: 100%; padding: 10px;" *ngIf="chunkedParameters != null && tabNames.length == 0">
      <tr *ngFor="let parameterRow of chunkedParameters.Rows"
        [style.border-top]="parameterRow.IncludeLineAtStartOfGroup ? '1px solid': ''"
        [style.border-bottom]="parameterRow.IncludeLineAtEndOfGroup ? '1px solid': ''">
        <td *ngFor="let parameter of parameterRow.Parameters" [colSpan]="parameter.SpanNumberOfColumns"
          [rowSpan]="parameter.SpanNumberOfRows" style="padding-left: 10px; padding-right: 10px; min-width: 130px;"
          [style.max-width]="200*parameter.SpanNumberOfColumns + 'px'">

          <div [ngStyle]="getParameterStyle(parameter)">
            <!-- Label -->
            <span
              *ngIf="parameter.ControlType=='lbl' && parameter.Name != '' && parameter.IsVisible == true">{{parameter.Name}}</span>

            <!-- Textbox -->
            <tyl-form-field label="{{parameter.Name}}"
              *ngIf="parameter.ControlType == 'txt' && parameter.IsVisible == true && parameter.DataType == 'VARCHAR'" class="parameterDefaultStyle">
              <input matInput [type]="parameter.DataType == 'VARCHAR' ? 'text': 'number'"
                name="txt{{parameter.Name}}_{{parameter.Id}}" [(ngModel)]="parameter.Value"
                maxlength="{{parameter.MaxLength}}" id="txt{{parameter.ParameterName}}_{{parameter.Id}}"
                [disabled]="parameter.Disabled" [required]="parameter.IsRequired" />
            </tyl-form-field>

             <!-- Textbox number -->
            <tyl-form-field label="{{parameter.Name}}"
             *ngIf="parameter.ControlType == 'txt' && parameter.IsVisible == true && parameter.DataType != 'VARCHAR'" class="parameterDefaultStyle">
             <input matInput type='number' name="txt{{parameter.Name}}_{{parameter.Id}}" [(ngModel)]="parameter.Value"
               maxlength="{{parameter.MaxLength}}" id="txt{{parameter.ParameterName}}_{{parameter.Id}}"
               [disabled]="parameter.Disabled" [required]="parameter.IsRequired" 
               [maximumEnforce]="999" />
            </tyl-form-field>

            <!-- Multi Line Textbox -->
            <tyl-form-field label="{{parameter.Name}}" style="width:95%;"
              *ngIf="parameter.ControlType == 'rtxt' && parameter.IsVisible == true"
              hint="{{parameter.MaxLength - parameter.Value.length}} characters left" class="parameterDefaultStyle">
              <textarea matInput #txtSummary type="text" name="txt{{parameter.Name}}_{{parameter.Id}}"
                [(ngModel)]="parameter.Value" id="txt{{parameter.ParameterName}}_{{parameter.Id}}"
                maxlength="parameter.MaxLength" style="resize: none;" [disabled]="parameter.Disabled"
                [required]="parameter.IsRequired"></textarea>
            </tyl-form-field>

            <!-- Date Picker -->
            <tyl-datepicker label="{{parameter.Name}}" [ngStyle]="getParameterStyle(parameter)"
              *ngIf="parameter.ControlType == 'dtp' && parameter.IsVisible == true"
              id="txt{{parameter.ParameterName}}_{{parameter.Id}}" [(value)]="parameter.Value"
              [disabled]="parameter.Disabled" [isRequired]="parameter.IsRequired" class="parameterDefaultStyle">
            </tyl-datepicker>

            <!-- Checkbox -->
            <tyl-checkbox *ngIf="parameter.ControlType == 'chk' && parameter.IsVisible == true"
              [(checked)]="parameter.Value" (change)="parameterChanged(parameter)"
              id="Cb{{parameter.ParameterName}}_{{parameter.Id}}" name="Cb{{parameter.Name}}_{{parameter.Id}}"
              [disabled]="parameter.Disabled" class="parameterDefaultStyle">
              {{parameter.Name}}
            </tyl-checkbox>

            <!-- Checkbox List -->
            <div *ngIf="parameter.ControlType == 'cbl' && parameter.IsVisible == true">
              <span *ngIf="parameter.Name != ''">{{parameter.Name}}</span>

              <div style="display: flex; flex-wrap: wrap;"
                [style.flex-direction]="parameter.ShowOptionsVertically ? 'column' : 'row'"
                [style.padding-left]="parameter.ChildPaddingLeft + 'px'" class="parameterDefaultStyle">
                <tyl-checkbox *ngFor="let dataItem of parameter.DataSource; let i = index" style="padding-right: 15px;"
                  [(checked)]="dataItem.IsSelected" [value]="dataItem.ValueField"
                  id="cbl{{parameter.ParameterName}}_{{parameter.Id}}_{{i}}"
                  name="cbl{{parameter.Name}}_{{parameter.Id}}_{{i}}" [disabled]="parameter.Disabled">
                  {{dataItem.TextField}}
                </tyl-checkbox>
              </div>
            </div>

            <!-- Dropdown List -->
            <tyl-form-field label="{{parameter.Name}}"
              *ngIf="parameter.ControlType == 'ddl' && parameter.IsVisible == true"  class="parameterDefaultStyle">
              <mat-select name="ddl{{parameter.Name}}_{{parameter.Id}}" [(ngModel)]="parameter.Value"
                id="ddl{{parameter.ParameterName}}_{{parameter.Id}}" (selectionChange)="parameterSelectionChange(parameter);parameterChanged(parameter)" [disabled]="parameter.Disabled"
                [required]="parameter.IsRequired">
                <mat-option *ngFor="let dataItem of parameter.DataSource" [value]="dataItem.ValueField">
                  {{dataItem.TextField}}
                </mat-option>
              </mat-select>
            </tyl-form-field>

            <!-- Dropdown List Multiple Setect -->
            <tyl-form-field label="{{parameter.Name}}"
              *ngIf="parameter.ControlType == 'ddcbl' && parameter.IsVisible == true">
              <mat-select id="ddcbl{{parameter.Name}}_{{parameter.Id}}" name="ddcbl{{parameter.Name}}_{{parameter.Id}}"
                [(ngModel)]="parameter.Value" multiple>
                <mat-select-trigger *ngIf="parameter.Value && parameter.Value.length > 1">
                  <span style="font-style:italic;">Multiple Selected</span>
                </mat-select-trigger>
                <mat-option (click)="parameterDropdownlistSelectChange(parameter,dataItem.ValueField)" *ngFor="let dataItem of parameter.DataSource" [(value)]="dataItem.ValueField">
                  {{dataItem.TextField}}
                </mat-option>
              </mat-select>
            </tyl-form-field>

            <!-- Radio Button List -->
            <div *ngIf="parameter.ControlType == 'rbl' && parameter.IsVisible == true">
              <span *ngIf="parameter.Name != ''">{{parameter.Name}}</span>

              <div [style.padding-left]="parameter.ChildPaddingLeft + 'px'" class="parameterDefaultStyle">
                <mat-radio-group name="rbl{{parameter.Name}}_{{parameter.Id}}" [(ngModel)]="parameter.Value"
                  id="rbl{{parameter.ParameterName}}_{{parameter.Id}}" style="display:flex; flex-wrap: wrap;"
                  [style.flex-direction]="parameter.ShowOptionsVertically ? 'column' : 'row'"
                  [disabled]="parameter.Disabled" (ngModelChange)="parameterChanged(parameter)">
                  <mat-radio-button *ngFor="let dataItem of parameter.DataSource" [value]="dataItem.ValueField">
                    {{dataItem.TextField}}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>

            <!-- Student Selection -->
            <div *ngIf="parameter.ControlType == 'ssrbl' && parameter.IsVisible == true">
              <span *ngIf="parameter.Name != ''">{{parameter.Name}}</span>
              <div [style.padding-left]="parameter.ChildPaddingLeft + 'px'" class="parameterDefaultStyle">
                <mat-radio-group name="ssrbl{{parameter.Name}}_{{parameter.Id}}" [(ngModel)]="parameter.Value"
                  id="ssrbl{{parameter.ParameterName}}_{{parameter.Id}}" style="display:flex; flex-wrap: wrap;"
                  [style.flex-direction]="parameter.ShowOptionsVertically ? 'column' : 'row'"
                  class="parameterDefaultStyle">
                  <mat-radio-button *ngFor="let dataItem of parameter.DataSource" [value]="dataItem.ValueField">
                    {{dataItem.TextField}}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
 
            <!-- Grid -->
            <div style="max-height: 300px;" *ngIf="parameter.ControlType == 'grid' && parameter.IsVisible == true && parameter.GridDataSources != null && parameter.GridDataSources !=''">
              <mat-table [dataSource]="parameter.GridDataSources" matSortDisableClear matSort (matSortChange)="sortData($event,parameter.GridDataSources)" style="display: grid;">
                <ng-container *ngFor="let disCol of parameter.ColumnToDisplay; let colIndex = index" matColumnDef="{{disCol}}">
                  <mat-header-cell *matHeaderCellDef [mat-sort-header]=" disCol != 'Selected' ? disCol : null" [disabled]=" disCol=='Selected' ? true : false " style="padding-left: 10px;">
                    <span *ngIf="disCol != 'Selected'">{{disCol}}</span>
                    <tyl-checkbox [(checked)]="selectAllGridRecords" (change)="selectAllGridRecordsChange()"
                      *ngIf="disCol == 'Selected'">
                    </tyl-checkbox>
                    <filter [data]="parameter.GridDataSources" columnName="{{disCol!= 'Selected' ? disCol : null}}" [hidden]=" disCol=='Selected' ? true : false " dataType="string"></filter>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" style="padding-left: 10px;">
                    <span *ngIf="disCol != 'Selected'" style="white-space: break-spaces;">
                      {{row[disCol]}}
                    </span>                    
                    <tyl-checkbox [(checked)]="row.Selected" *ngIf="disCol == 'Selected'"></tyl-checkbox>                    
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="parameter.ColumnToDisplay; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: parameter.ColumnToDisplay;" 
                style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple class="element-row"></mat-row>
              </mat-table>
            </div>

            <!-- Button -->
            <div *ngIf="parameter.ControlType == 'btn' && parameter.IsVisible == true">
              <tyl-button id="btn{{parameter.ParameterName}}_{{parameter.Id}}" [label]="parameter.Name" image="{{imageIconName}}" (clickEvent)="searchClick(parameter)"
               translate></tyl-button>
           </div>  

           <!-- Staff Picker -->
           <div *ngIf="parameter.ControlType == 'stp' && parameter.IsVisible == true" style="display: flex;" [style.flex-direction]="column">
              <tyl-form-field label="{{parameter.Name}}" class="parameterDefaultStyle">
                <input matInput [type]="parameter.DataType == 'VARCHAR' ? 'text': 'number'"
                  name="txt{{parameter.ParameterName}}_{{parameter.Id}}" [(ngModel)]="parameter.selectedStaffNames"
                  maxlength="{{parameter.MaxLength}}" id="txt{{parameter.ParameterName}}_{{parameter.Id}}"
                  [disabled]="parameter.Disabled" [required]="parameter.IsRequired" readonly />
              </tyl-form-field>
              <tyl-button id="btn{{parameter.ParameterName}}_{{parameter.Id}}" style="height: 50px;"
                image="{{imageIconName}}" (clickEvent)="searchClick(parameter)" translate></tyl-button>
            </div>

            <div *ngIf="parameter.Hint != '' && parameter.IsVisible == true">{{parameter.Hint}}</div>            
          </div>
        </td>
      </tr>
    </table>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="flex-footer-left">
    <tyl-button label="Legend" image="Legend.png" (clickEvent)="legendClick()" *ngIf="showLegend"></tyl-button>  
    <div *ngIf="blnIsParameterLink == true" style="padding-left: 20px;">
      <a  (click)="parameterLinkClick('Print and Delivery Options')">Print and Delivery Options</a>
    </div>       
  </div>
  <div class='flex-footer-right'>
    <error-prompt [errorList]="errors"></error-prompt>
    <span style="padding-top: 10px;" *ngIf="blnSaveReportCardMessage == true"><button (click)="saveRCMessages()">Save Changes to Report Card Messages</button></span>
    <tyl-button label="Run" image="Save.png" (clickEvent)="runReportClick(); validationTrigger.click();"></tyl-button>
    <tyl-button label="Cancel" image="Cancel.png" (clickEvent)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>
<input type="submit" form="v9ReportParameterForm" style="display: none" #validationTrigger>
